//get the Gateway
require("../../../../js/gateway.js");

//for webinar notifications
//require("bootstrap/bootstrap-notify.min.js");
//require("generic-promo-banner.js");

//adding spin.js which might be a global dependancy.
import {Spinner} from 'spin.js';
window.Spinner = Spinner;


// old override scripts
require("./override.js");

// main nav
require("./main-nav.js");

// custom validations
require("./custom-validations.js");

//lazy loading
require("../../lazy-loader.js");

//insights scripts
require("./insights-components");

//insights scripts
require("./share-widget.js");

//webinar notifications
require("./generic-promo-banner.js");

//component JS
require("./components.js");

//pop-up newsletters
require("./newsletter-popups.js");

//landing-page-hero-video
require("./video/landing-page-hero-video.js");

//export jQuery for outside use.
window.$ = $;

// spinner js
require("./spinner.js");

// menu-masthead-footer
require("./menu-masthead-footer");

//direct investing videos 
require("./video/direct-investing-page-videos");

require("./ucits-homepage.js");

//responsive background images
require("./background-images.js");

//responsive videos
require("./video/responsive-video.js");

//video carousel disclosure modal
require("./video-carousel-disclosure-modal.js");